import { render, staticRenderFns } from "./bulkAssignModal.vue?vue&type=template&id=25e1f348&scoped=true"
import script from "./bulkAssignModal.vue?vue&type=script&lang=js"
export * from "./bulkAssignModal.vue?vue&type=script&lang=js"
import style0 from "./bulkAssignModal.vue?vue&type=style&index=0&id=25e1f348&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25e1f348",
  null
  
)

export default component.exports